/**
 * @description 查詢系統訊息代號 代號類別 (CODE_CLASS) 參數用
 */
export enum CodeClass {
  All = '0',
  UI = 'UI',
  ENDORSE = 'ENDORSE',
  EXTENMSG = 'EXTENMSG',
  CREDITCARD_BANK = 'CREDITCARD_BANK',
  COMPENSATION = 'COMPENSATION',
  INS_DONE = 'INS_DONE',
  INS_DONE_BAR = 'INS_DONE_BAR',
  PAYMENTACK = 'PAYMENTACK',
  PAYMENTBACCT = 'PAYMENTBACCT',
  PAYMENTCARD = 'PAYMENTCARD',
  PAYMENTORC = 'PAYMENTORC',
  POL_VAL = 'POL_VAL',
  QUICKCLAIM = 'QUICKCLAIM',
  QUICKCLAIMRM = 'QUICKCLAIMRM',
  TIP = 'TIP',
  TRRM = 'TRRM',
  CARRM = 'CARRM',
  MOTORM = 'MOTORM',
  ePolicy = 'ePolicy',
  FastCLM = 'FastCLM',
  FastCLMRM = 'FastCLMRM',
  QCRM = 'QCRM',
  CARSURVEYDONE = 'CARSURVEYDONE',
  PRODEXT = 'PRODEXT',
  MOBDEVRM = 'MOBDEVRM',
  BARCODE_NOTE = 'BARCODE_NOTE',
  BARCODE_NOTICE = 'BARCODE_NOTICE',
  FIREPROPRM = 'FIREPROPRM',
  POLICY_QUERY = 'POLICY_QUERY',
  WPA = 'WPA'
}
